import { CSSProperties, FC, ReactNode, useState } from "react";
import SelectDropdown from "../SelectDropdown/SelectDropdown";

interface SelectDropdownWrapperProps<T> {
    items: T[];
    renderItem: (item: T) => ReactNode;
    defaultItem?: T;
    onChange?: (item: T) => void;
    defaultText?: string;
    optionsContainerStyle?: CSSProperties;
    optionsListStyle?: CSSProperties;
}

const SelectDropdownWrapper = <T,>({
    items,
    renderItem,
    defaultItem,
    onChange,
    defaultText,
    optionsContainerStyle,
    optionsListStyle,
}: SelectDropdownWrapperProps<T>) => {
    const [currentItem, setCurrentItem] = useState<T | undefined>(defaultItem);

    return (
        <div className="select-dropdown-wrapper-container">
            <SelectDropdown optionsContainerStyle={optionsContainerStyle} optionsListStyle={optionsListStyle}>
                <SelectDropdown.Selected>{currentItem ? renderItem(currentItem) : defaultText}</SelectDropdown.Selected>
                {items.map((item) => (
                    <SelectDropdown.Option>
                        <div
                            onClick={() => {
                                setCurrentItem(item);
                                onChange && onChange(item);
                            }}
                        >
                            {renderItem(item)}
                        </div>
                    </SelectDropdown.Option>
                ))}
            </SelectDropdown>
        </div>
    );
};

export default SelectDropdownWrapper;
